<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title> Abwesenheitsübersicht </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div>
      <div class="stretch">
        <div>Name:</div>
        <div>
          {{ state.getUserDisplayNameAsync(absenceEntry?.user) | async }}
        </div>
      </div>

      <!--div class="stretch">
        <div>Start:</div>
        <div>{{ this.tools.formatDt(absenceEntry?.timeEntry.start) }}</div>
      </div>
      <div class="stretch">
        <div>Ende:</div>
        <div>{{ this.tools.formatDt(absenceEntry?.timeEntry.end) }}</div>
      </div>
      <div class="stretch">
        <div>Dauer:</div>
        <div>{{ absenceDays }}</div>
      </div-->
      <div class="stretch">
        <div>Datum:</div>
        <div>{{ absenceEntry?.date | date : "dd.MM.yyyy" }}</div>
      </div>

      <div class="stretch" *ngIf="absenceEntry?.type">
        <div>Typ:</div>
        <div>{{ absenceEntry?.type }}</div>
      </div>
      <div class="stretch" *ngIf="absenceEntry?.approvedBy">
        <div>Status:</div>
        <div class="centered">
          <div>Bestätigt</div>
          <ion-icon
            style="color: rgb(0, 179, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
        </div>
      </div>

      <div
        class="stretch"
        *ngIf="!absenceEntry?.approvedBy && !absenceEntry?.rejectedBy"
      >
        <div>Status:</div>
        <div class="centered">
          <div>In Bearbeitung</div>
          <ion-icon
            style="color: rgb(255, 174, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
        </div>
      </div>
      <div class="stretch" *ngIf="absenceEntry?.rejectedBy">
        <div>Status:</div>
        <div class="centered">
          <div>Abgelehnt</div>
          <ion-icon
            style="color: rgb(228, 0, 0)"
            name="checkmark-circle-outline"
          ></ion-icon>
        </div>
      </div>
      <div *ngIf="absenceEntry?.description">
        <div><b>Beschreibung:</b></div>
        <div>{{ absenceEntry?.description }}</div>
      </div>
      <div *ngIf="absenceEntry?.rejectedMessage">
        <div><b>Beschreibung:</b></div>
        <div>{{ absenceEntry?.rejectedMessage }}</div>
      </div>
      <div class="stretch cut">
        <div>Erstellt:</div>
        <div>
          {{ state.getUserDisplayNameAsync(absenceEntry?.createdBy) | async }}
          ({{ this.tools.formatDt(absenceEntry?.createdUtc) }},
          {{ this.tools.formatTime(absenceEntry?.createdUtc, true) }})
        </div>
      </div>
      @if(absenceEntry?.lastModifiedDateUtc && absenceEntry?.lastModifiedDateUtc
      != absenceEntry?.createdUtc){
      <div class="stretch">
        <div>Zuletzt bearbeitet:</div>
        <div>
          {{ state.getUserDisplayNameAsync(absenceEntry?.createdBy) | async }}
          ({{ this.tools.formatDt(absenceEntry?.lastModifiedDateUtc) }},
          {{ this.tools.formatTime(absenceEntry?.lastModifiedDateUtc, true) }})
        </div>
      </div>
      }
    </div>

    <div class="stretch">
      @if((absenceEntry?.approvedBy == null && !state.userHasMinType(1)) ||
      (state.userHasMinType(1) && isTodayOrInFuture ) ||
      state.userHasMinType(2)|| (state.userHasMinType(1) &&
      absenceEntry?.rejectedBy != null )){
      <ion-button style="width: 100%" (click)="editWorkDay()"
        >Bearbeiten</ion-button
      >

      <ion-button
        style="width: 100%"
        color="danger"
        (click)="deleteAbsenceEntry()"
        >Löschen</ion-button
      >} @if(absenceEntry?.approvedBy == null && ((state.userHasMinType(1) &&
      isTodayOrInFuture ) || state.userHasMinType(2) || (state.userHasMinType(1)
      && absenceEntry?.rejectedBy != null ))){
      <ion-button style="width: 100%" color="success" (click)="approveEntry()"
        >Bestätigen</ion-button
      >} @if(absenceEntry?.rejectedBy == null && ((state.userHasMinType(1) &&
      isTodayOrInFuture ) || state.userHasMinType(2))){
      <ion-button style="width: 100%" color="danger" (click)="rejectEntry()"
        >Ablehnen</ion-button
      >}
    </div>
  </div>
</ion-content>
